import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      ",
        " {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n      }\n\n      ",
        " {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n      display: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
var Wrapper = /*#__PURE__*/ styled("div", {
    target: "e2qcobp0"
})("position:relative;display:flex;flex-direction:column;justify-content:center;");
var List = /*#__PURE__*/ styled("ul", {
    target: "e2qcobp1"
})("display:grid;grid-template-columns:repeat(1,minmax(0,1fr));gap:0;", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{column-gap:", function(param) {
    var length = param.length, theme = param.theme;
    return length >= 6 ? theme.spacing[80] : 0;
}, ";}", function(param) {
    var length = param.length, theme = param.theme;
    return length >= 6 && css(_templateObject(), theme.mq("md"), theme.mq("lg"));
});
var ListItem = /*#__PURE__*/ styled("li", {
    target: "e2qcobp2"
})("min-width:150px;border-bottom:", function(param) {
    var theme = param.theme;
    return "1px solid ".concat(theme.color.natural20);
}, ";padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";padding-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[40];
}, ";position:relative;", function(param) {
    var linksAreExpanded = param.linksAreExpanded, maxVisibleLinks = param.maxVisibleLinks, index = param.index;
    return !linksAreExpanded && maxVisibleLinks <= index && css(_templateObject1());
});
export { Wrapper, List, ListItem };
